import { render, staticRenderFns } from "./WeeklyPlanAddItemPopup.vue?vue&type=template&id=248e53f6&scoped=true&"
import script from "./WeeklyPlanAddItemPopup.vue?vue&type=script&lang=js&"
export * from "./WeeklyPlanAddItemPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e53f6",
  null
  
)

export default component.exports